export default __webpack_public_path__ + "static/media/header-XC90.bd19a516.jpg";